if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Ajouter un état pour éviter les double-clics
        this.isSubmitting = false;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const isUpsell = this.dataset.upsellCart === 'true';

        console.log(isUpsell, 'isUpsell');

        // Éviter les double-clics pour améliorer l'INP
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.isSubmitting) return;

        this.isSubmitting = true;
        this.handleErrorMessage();

        // Utiliser requestAnimationFrame pour les manipulations DOM
        requestAnimationFrame(() => {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');
        });

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;

              // Utiliser requestAnimationFrame pour les manipulations DOM
              requestAnimationFrame(() => {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              });
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              const eventData = {
                source: 'product-form',
                productVariantId: formData.get('id'),
                productId: formData.get('product-id'),
                isUpsell: isUpsell,
                cartData: response,
              };

              // Si c'est un pack, ajouter l'ID du premier produit pour les recommandations
              const packFirstProductId = this.dataset.packFirstProduct;
              if (packFirstProductId) {
                eventData.packFirstProductId = packFirstProductId;
              }

              publish(PUB_SUB_EVENTS.cartUpdate, eventData);
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const detailsModal = this.closest('.card__details-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  // Utiliser requestIdleCallback pour différer le rendu
                  if ('requestIdleCallback' in window) {
                    requestIdleCallback(() => {
                      this.cart.renderContents(response);
                    });
                  } else {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    }, 0);
                  }
                },
                { once: true },
              );
              if (quickAddModal) quickAddModal.hide(true);
            } else if (detailsModal) {
              detailsModal.click();
              this.cart.renderContents(response);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // Utiliser requestAnimationFrame pour les manipulations DOM finales
            requestAnimationFrame(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
              this.isSubmitting = false;
            });
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    },
  );
}
